import { render, staticRenderFns } from "./ParticipantForm.vue?vue&type=template&id=788d1110&"
import script from "./ParticipantForm.vue?vue&type=script&lang=ts&"
export * from "./ParticipantForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports